import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../../../components/ui/Card";
import EvaluationStatus from "./EvaluationStatus";
import { StatusLevel } from "../../../types";

interface AnalysisSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  status?: StatusLevel;
}

const AnalysisSection = ({
  title,
  children,
  className = "",
  status,
}: AnalysisSectionProps) => {
  return (
    <section className={` ${className}`}>
      <Card className="!border-0 !shadow-none">
        {/* Subtle background on the header */}
        <CardHeader className="bg-[#F7F7F7] px-4 py-3">
          <div className="flex justify-between items-center">
            <CardTitle className="text-base font-semibold text-gray-800">
              {title}
            </CardTitle>
            {status && <EvaluationStatus status={status} />}
          </div>
        </CardHeader>
        <CardContent className="p-4">
          <div className="space-y-4">{children}</div>
        </CardContent>
      </Card>
    </section>
  );
};

export default AnalysisSection;
